import Cookies from "js-cookie";
import { logger } from "./logger";
import { isBrowser } from "./ssr";

const _hsq = isBrowser() ? (window._hsq = window._hsq || []) : [];

export const trackPageView = () => {
  _hsq.push([
    "setPath",
    window.location.pathname + window.location.search + window.location.hash,
  ]);
  _hsq.push(["trackPageView"]);
};
export const identifyAndTrackPageView = (email: string) => {
  _hsq.push([
    "identify",
    {
      email,
    },
  ]);
  trackPageView();
};

export const trackSignupProvider = async (provider: string) => {
  const hutk = Cookies.get("hubspotutk");

  await fetch(import.meta.env.PUBLIC_HUBSPOT_SIGNUP_FORM_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      fields: [
        { objectTypeId: "0-1", name: "signup_provider", value: provider },
      ],
      context: {
        hutk,
      },
    }),
  });
  logger("[HUBSPOT] Tracking signup provider completed");
};
